import React from "react";
import { Link } from "react-router-dom";
import LegalPage from "@/components/LegalPage";

export default function Cookie() {
  return (
    <LegalPage title="Cookie Policy" description="Informativa sull'uso dei cookie su HostMarket" testid="cookie-page">
      <p>HostMarket utilizza cookie e tecnologie simili per offrire il servizio e migliorare l'esperienza di navigazione. Questa pagina descrive quali cookie impieghiamo e come gestirli.</p>

      <h2>1. Cosa sono i cookie</h2>
      <p>I cookie sono piccoli file di testo salvati sul tuo dispositivo dai siti web che visiti. Possono essere <em>di prima parte</em> (emessi dal sito visitato) o <em>di terza parte</em> (emessi da servizi esterni).</p>

      <h2>2. Cookie utilizzati da HostMarket</h2>

      <h3>2.1 Cookie tecnici essenziali <span className="text-[#22C55E]">(sempre attivi)</span></h3>
      <ul>
        <li><strong>hm_token</strong>: token JWT di sessione utente (scade dopo 7 giorni). Obbligatorio per l'autenticazione.</li>
        <li><strong>hm_cookie_consent_v1</strong>: ricorda la tua scelta sui cookie (scade dopo 12 mesi).</li>
        <li>Cookie di sessione del server (anti-CSRF, load balancing).</li>
      </ul>
      <p>Base giuridica: <strong>esecuzione del contratto</strong> (Art. 6.1.b GDPR) e <strong>legittimo interesse</strong> per la sicurezza. Non richiedono consenso.</p>

      <h3>2.2 Cookie analitici <span className="text-[#FFBE00]">(opzionali)</span></h3>
      <p>Al momento HostMarket non utilizza strumenti di analytics di terze parti. Se in futuro integreremo strumenti come Plausible, Matomo o Google Analytics, saranno attivati solo previo tuo consenso esplicito dal banner cookie.</p>

      <h3>2.3 Cookie di marketing <span className="text-zinc-400">(non utilizzati)</span></h3>
      <p>HostMarket non utilizza cookie pubblicitari di terze parti (Google Ads, Meta Pixel, TikTok Pixel ecc.) e non profila gli utenti per finalità commerciali esterne.</p>

      <h2>3. Cookie tecnici di terze parti</h2>
      <ul>
        <li><strong>Stripe</strong>: durante il checkout, Stripe Elements può usare cookie tecnici per la sicurezza anti-frode (3D Secure, fingerprinting antifrode). Consulta la <a href="https://stripe.com/privacy" target="_blank" rel="noreferrer">privacy policy di Stripe</a>.</li>
      </ul>

      <h2>4. Come gestire i cookie</h2>
      <p>Puoi modificare il consenso in qualsiasi momento:</p>
      <ul>
        <li>Cliccando sulla voce "Cookie" nel footer del sito per riaprire il banner preferenze.</li>
        <li>Cancellando i cookie dal tuo browser: dalle impostazioni privacy del browser (Chrome, Firefox, Safari, Edge) puoi cancellare i cookie memorizzati e bloccare quelli futuri.</li>
        <li>Usando la modalità di navigazione privata/in incognito.</li>
      </ul>

      <h2>5. Conseguenze del rifiuto</h2>
      <p>I cookie tecnici sono necessari: senza di essi non puoi effettuare login né usare la dashboard. Il rifiuto dei cookie opzionali non compromette alcuna funzionalità.</p>

      <h2>6. Aggiornamenti</h2>
      <p>Questa Cookie Policy può essere aggiornata in caso di integrazioni future. La data di ultima modifica è indicata in cima alla pagina.</p>

      <h2>7. Contatti</h2>
      <p>Per qualunque domanda scrivici a <a href="mailto:team@vitadahost.it">team@vitadahost.it</a>. Vedi anche la nostra <Link to="/privacy">Privacy Policy</Link>.</p>
    </LegalPage>
  );
}
